module.exports = __webpack_public_path__ + "img/gift.df691244.png";